import {Component, Input} from '@angular/core';
import {MdDialog} from '@angular/material';
import {ExceptionDialogComponent} from '../../../utilities/components/exception-dialog/exception-dialog.component';
import {FieldValue} from '../../../form-renderer/interfaces/FieldValue';


@Component({
  selector: 'app-exception-field',
  templateUrl: './exception-field.component.html',
  styleUrls: ['./exception-field.component.scss']
})
export class ExceptionFieldComponent {

  constructor(public dialog: MdDialog) { }

  @Input() fieldValue: FieldValue;
  @Input() disabled = false;


  get color() {
    return this.fieldValue.string_value ? 'primary' : 'black';
  }

  exceptionService(): void {
    this.dialog.open(ExceptionDialogComponent, {
      data: {
        exceptionId: this.fieldValue.flight_field_group_id,
        exceptionText: this.fieldValue.string_value
      },
      disableClose: true
    }).afterClosed()
      .subscribe(result => {
        if (result === null) {
          return;
        }
        this.fieldValue.string_value = result;
      })
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/exception-field/exception-field.component.ts